/** Country-aware mobile helpers (Naturals + portal forms). */
import {
  DEFAULT_WHATSAPP_COUNTRY,
  getCountryIso2FromPhone,
  getWhatsAppValidationMessage,
  normalizeWhatsAppValue,
  validateWhatsAppNumberByCountry,
} from '../../shared/utils/whatsappPhone';

export const MOBILE_10_ERROR = 'Enter a valid mobile number for the selected country';

export function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

export function nationalMobileDigits(value) {
  let d = digitsOnly(value).replace(/^0+/, '');
  if (d.startsWith('91') && d.length > 10) d = d.slice(2);
  return d;
}

/** @deprecated Use CountryWhatsAppInput — kept for legacy plain inputs. */
export function constrainMobileInput(value) {
  return nationalMobileDigits(value).slice(0, 10);
}

export function isValidMobileForCountry(value, countryIso2 = DEFAULT_WHATSAPP_COUNTRY) {
  return validateWhatsAppNumberByCountry(value, countryIso2);
}

/** India-only legacy alias. */
export function isValidMobile10(value) {
  return isValidMobileForCountry(value, 'in');
}

export function mobileValidationError(countryLabel = 'selected country') {
  return getWhatsAppValidationMessage(countryLabel);
}

export function normalizeRegisterMobileValue(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (s.startsWith('+')) return normalizeWhatsAppValue(s);
  const national = nationalMobileDigits(s);
  if (national.length === 10) return `+91${national}`;
  return normalizeWhatsAppValue(s);
}

export function isRegisterMobileComplete(value) {
  const normalized = normalizeRegisterMobileValue(value);
  const digits = normalized.replace(/\D/g, '');
  if (digits.length <= 2) return false;
  const country = getCountryIso2FromPhone(normalized) || DEFAULT_WHATSAPP_COUNTRY;
  return isValidMobileForCountry(normalized, country);
}
